<template>
  <section id="catalog-list">
    <catalog-list
      :query="query"
      :selected.sync="selectedItem"
      :loadingItem="loadingItem"
      @select="onSelected"
    />

    <hr />

    <section id="item" style="min-height: 600px;">
      <catalog-item
        v-if="selectedItem"
        :catalog_no="selectedItem.catalog_no"
        :loading.sync="loadingItem"
        @updated="onUpdated"
      />
    </section>

    <b-loading :active="isLoading" :is-full-page="true" :can-cancel="false" />
  </section>
</template>

<script>
import CatalogList from '@/components/catalogs/CatalogList'
import CatalogItem from '@/components/catalogs/CatalogItem'

export default {
  name: 'Catalogs',
  components: {
    CatalogList,
    CatalogItem
  },

  data() {
    const { query } = this.$route

    return {
      query: query,
      loadingItem: false,
      selectedItem: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  },
  computed: {
    isLoading() {
      return this.loadingItem
    }
  },
  methods: {
    onUpdated(item) {
      this.selectedItem = item
    },
    onSelected(item) {
      if (item) {
        this.$scrollTo(`#item`, { offset: -60 })
      } else {
        this.$scrollTo(`#catalog-list`, { offset: -60 })
      }
    }
  }
}
</script>

<style scoped></style>
